// import React, { Component, useEffect, useState } from "react";
import "../chart.css"; import { useMemo } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

export default function ErrorLogsChart({ graphData = [] }) {
    const { chartData, serverIds, maxValue } = useMemo(() => {
        const groupedByDate = new Map();
        const serversSet = new Set();
        let localMax = 0;

        for (const row of graphData) {
            const dateKey = row.created_at;
            const serverId = row.server_id;
            const count = Number(row.vless_count) || 0;

            serversSet.add(serverId);

            if (!groupedByDate.has(dateKey)) {
                groupedByDate.set(dateKey, {
                    created_at: dateKey,
                });
            }

            const existingRow = groupedByDate.get(dateKey);
            existingRow[serverId] = count;

            if (count > localMax) {
                localMax = count;
            }
        }

        const serverIdsArray = Array.from(serversSet).sort();

        const normalizedData = Array.from(groupedByDate.values())
            .map((row) => {
                for (const serverId of serverIdsArray) {
                    if (row[serverId] == null) {
                        row[serverId] = 0;
                    }
                }
                return row;
            })
            .sort((a, b) => {
                const [da, ma, ya] = a.created_at.split("/").map(Number);
                const [db, mb, yb] = b.created_at.split("/").map(Number);

                const dateA = new Date(ya, ma - 1, da).getTime();
                const dateB = new Date(yb, mb - 1, db).getTime();

                return dateA - dateB;
            });

        return {
            chartData: normalizedData,
            serverIds: serverIdsArray,
            maxValue: localMax > 0 ? localMax : 1,
        };
    }, [graphData]);

    const isMobile =
        typeof window !== "undefined"
            ? window.matchMedia("(max-width: 800px)").matches
            : false;

    const CustomTooltip = ({ active, payload, label }) => {
        if (!active || !payload || !payload.length) {
            return null;
        }

        const filteredPayload = payload
            .filter((item) => Number(item.value) > 0)
            .sort((a, b) => Number(b.value) - Number(a.value));

        return (
            <div className="custom-tooltip">
                <div className="custom-tooltip-date">{label}</div>
                <div>
                    {filteredPayload.length > 0 ? (
                        filteredPayload.map((pld) => (
                            <div
                                className="custom-tooltip-content"
                                key={pld.dataKey}
                            >
                                <div>{pld.dataKey}</div>
                                <div>{pld.value}</div>
                            </div>
                        ))
                    ) : (
                        <div className="custom-tooltip-content">
                            <div>No data</div>
                            <div>0</div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="charts-grid">
                <ResponsiveContainer className="custom-container">
                    <LineChart
                        margin={{ top: 32, left: 32, right: 32, bottom: 32 }}
                        width={isMobile ? 350 : 500}
                        height={500}
                        data={chartData}
                    >
                        <YAxis
                            hide={true}
                            domain={[0, maxValue]}
                            allowDecimals={false}
                        />

                        <XAxis
                            hide={true}
                            dataKey="created_at"
                        />

                        <Tooltip content={<CustomTooltip />} />

                        {serverIds.map((serverId, index) => (
                            <Line
                                key={serverId}
                                dot={false}
                                type="monotone"
                                dataKey={serverId}
                                name={serverId}
                                stroke={
                                    [
                                        "#FFF",
                                        "#909090",
                                        "#606060",
                                        "#C0C0C0",
                                        "#AAAAAA",
                                        "#777777",
                                        "#DDDDDD",
                                    ][index % 7]
                                }
                            />
                        ))}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </>
    );
}